export default "<router-outlet></router-outlet>\r\n<ngx-spinner [fullScreen]=\"true\" type=\"ball-clip-rotate-multiple\" size=\"large\"></ngx-spinner>\r\n";